<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-29 15:07:45
 * @LastEditTime: 2021-04-30 09:44:06
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <template v-slot:content>
      <div class="page-header-content">
        <div class="avatar">
          <a-avatar :size="80" :src="userInfo.avatar ? globalUrl + userInfo.avatar : '/avatar.png'" />
        </div>
        <div class="content">
          <div class="content-title">
            {{ userInfo.username }}
          </div>
          <div class="content-description">
            {{ timeFix }}，{{ welcome }}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:extraContent>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-statistic title="末次登录" :value="userInfo.updated_at" />
        </a-col>
      </a-row>
    </template>
    <a-card :bordered="false">
      <a-tabs tab-position="left">
        <!-- 基本设置 -->
        <a-tab-pane key="1" tab="基本设置">
          <base-setting />
        </a-tab-pane>
        <a-tab-pane key="2" tab="修改密码">
          <!-- 修改密码 -->
          <edit-pass-word />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form } from '@/mixins' // 引入
import { EditPassWord, BaseSetting } from './page'
import { mapState } from 'vuex'
import { timeFix } from '@/utils/util'

export default {
    mixins: [form], // 使用mixins
    components: {
        EditPassWord,
        BaseSetting
    },
    data () {
        return {
            timeFix: timeFix()
        }
    },
    computed: {
        ...mapState({
            welcome: state => state.user.welcome
        }),
        userInfo () {
            return this.$store.getters.userInfo
        }
    },
    mounted () {},
    methods: {

    }
}
</script>

<style lang="less" scoped>
.page-header-content {
    display: flex;
    align-items: center;
    .avatar {
        margin-right: 1rem;
    }
    .content-title {
        font-size: 1.25rem;
        font-weight: bold;
    }
}
/deep/.ant-statistic-content-value {
    font-size: 1.125rem;
    font-weight: 600;
}
</style>
